import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as types from '../../../constants/actionTypes';
import MultiSelectBox from '../MultiSelectBox/MultiSelectBox';
import LoadingIndicator from '../LoadingIndicator/LoadingIndicator';
import Notification from '../Notification';
import './UserLocationAccessForm.scss';

export default class UserLocationAccessForm extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            isLoading: false,
            areas: [],
            brands: [],
            continents: [],
            countries: [],
            locationTypes: [],
            managementCompanies: [],
            regions: []
        };
    }

    async componentDidMount() {
        try {
            const filters = this.props.formFilters;
            if (filters && filters.areas && filters.brands && filters.continents
                && filters.countries && filters.locationTypes
                && filters.managementCompanies && filters.regions) {
                this.setState({
                    areas: filters.areas,
                    brands: filters.brands,
                    continents: filters.continents,
                    countries: filters.countries,
                    locationTypes: filters.locationTypes,
                    managementCompanies: filters.managementCompanies,
                    regions: filters.regions,
                })
            }
            else {
                this.setState({ isLoading: true });
                const response = await this.props.actions.loadFormFilters(this.props.subscriptionId);
                if (response.type === types.LOAD_LOCATION_FORM_FILTERS_SUCCESS) {
                    this.setState({
                        areas: response.payload.areas,
                        brands: response.payload.brands,
                        continents: response.payload.continents,
                        countries: response.payload.countries,
                        locationTypes: response.payload.locationTypes,
                        managementCompanies: response.payload.managementCompanies,
                        regions: response.payload.regions,
                    });
                } else if (response.type === types.LOAD_LOCATION_FORM_FILTERS_FAILURE) {
                    Notification("error", "An Error Occurred", response.payload.message);
                }
            }
        } catch (error) {
            Notification("error", "Error", error);
        } finally {
            this.setState({ isLoading: false });
        }
    }

    onMultiSelectChange = (csv, name) => {
        this.props.onFormChange(name, csv);
    }

    render() {
        return (
            <div className="user-location-access-form">
                <LoadingIndicator isLoading={this.state.isLoading}>
                    {
                        this.props.isFormValid ?
                            null
                            :
                            <div className="invalid-feedback">
                                At least one location access rule attribute must have at least one value
                        </div>
                    }
                    <MultiSelectBox name="areas" label="Area" idField="id" valueField="name"
                        options={this.state.areas}
                        selectedValues={this.props.userLocationRules.areas}
                        onChange={this.onMultiSelectChange}
                        isMulti={true}
                    />

                    <MultiSelectBox name="brands" label="Brand" idField="id" valueField="name"
                        options={this.state.brands}
                        selectedValues={this.props.userLocationRules.brands}
                        onChange={this.onMultiSelectChange}
                        isMulti={true}
                    />

                    <MultiSelectBox name="continents" label="Continent" idField="id" valueField="name"
                        options={this.state.continents}
                        selectedValues={this.props.userLocationRules.continents}
                        onChange={this.onMultiSelectChange}
                        isMulti={true}
                    />

                    <MultiSelectBox name="countries" label="Country" idField="id" valueField="name"
                        options={this.state.countries}
                        selectedValues={this.props.userLocationRules.countries}
                        onChange={this.onMultiSelectChange}
                        isMulti={true}
                    />

                    <MultiSelectBox name="locationTypes" label="Type" idField="id" valueField="name"
                        options={this.state.locationTypes}
                        selectedValues={this.props.userLocationRules.locationTypes}
                        onChange={this.onMultiSelectChange}
                        isMulti={true}
                    />

                    <MultiSelectBox name="managementCompanies" label="Management Company" idField="id" valueField="name"
                        options={this.state.managementCompanies}
                        selectedValues={this.props.userLocationRules.managementCompanies}
                        onChange={this.onMultiSelectChange}
                        isMulti={true}
                    />

                    <MultiSelectBox name="regions" label="Region" idField="id" valueField="name"
                        options={this.state.regions}
                        selectedValues={this.props.userLocationRules.regions}
                        onChange={this.onMultiSelectChange}
                        isMulti={true}
                    />
                </LoadingIndicator>
            </div>
        );
    }
}

UserLocationAccessForm.propTypes = {
    subscriptionId: PropTypes.string.isRequired,
    formFilters: PropTypes.object,
    isFormValid: PropTypes.bool.isRequired,
    userLocationRules: PropTypes.object.isRequired,
    onFormChange: PropTypes.func.isRequired,
    actions: PropTypes.object.isRequired
}
